import { TagCellContext } from "./types";

export function TagSystemName({ row }: TagCellContext<string>) {
  const tag = row.original;
  return <span className="italic text-gray-200">{tag.tempSystemName || tag.systemName}</span>;
}
